import ApiClient from "../../api-client";
import { API_URL } from "../../environment";
import { Buffer } from 'buffer'; // Only needed if `btoa` is not available (e.g., in Node.js)

export const signUp = ({values, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/signup`, values, null, dispatch);
};

export const signIn = ({ values, dispatch }) => {
    const encodedEmail = Buffer.from(values.email).toString('base64');
    const encodedPassword = Buffer.from(values.password).toString('base64');

    const encodedValues = {
        ...values,
        email: encodedEmail,
        password: encodedPassword
    };

    return ApiClient.post(`${API_URL}/auth/login`, encodedValues, null, dispatch);
};

export const forgotPassword = ({values, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/forget-password`, values, null, dispatch);
};

export const resetPassword = ({values, email, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/reset-password?email=${email}`, values, null, dispatch);
};

export const resetTempPassword = ({values, dispatch}) => {
    return ApiClient.put(`${API_URL}/auth/resetTempPassword`, values, null, dispatch);
};

export const changePassword = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/auth/change-password`, values, token, dispatch);
};

export const resendOtp = ({values, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/resend-otp`, values, null, dispatch);
};

export const verifyOtp = ({values, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/verify-otp`, values, null, dispatch);
};

export const getUserDetails = ({values, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/user-details`, values, null, dispatch);
};

export const getPatientDetails = ({values, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/patient-details`, values, null, dispatch);
};
